
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import HISReferenceListForARTSerializer from '../types/HISReferenceListForARTSerializer_apps_INF'


const HOST = `${config.API_HOST}`
/* ['MultiplePaginationMixin', 'generics.ListAPIView'] */
/* params: 'enc_type', 'start_date', 'end_date', 'ar_transaction', 'filter_only_c', 'status', 'coverage_payer_sent_claim_group', 'patient', 'encounter', 'coverage', 'payer_id', 'order_by_date_transaction', 'exclude_zero_claim_amount' */
/* data:  */
const HISReferenceListForART : 
{
  list:     ({params, apiToken, extra}:
             { 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  list: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/INF/his-reference-list-art/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default HISReferenceListForART

